import apiClient from './client';

export interface AnalyticsFilterParams {
  startDate?: string;
  endDate?: string;
  staffId?: string;
}

export interface DashboardStats {
  deals: {
    stages: Record<string, number>;
    totalDeals: number;
    totalValue: number;
    avgDealValue: number;
  };
  staff: Array<{
    staffId: string;
    totalAssignments: number;
    completed: number;
    inProgress: number;
    avgCompletionDays: number;
  }>;
  revenue: {
    totalRevenue: number;
    completedPayments: number;
    pendingPayments: number;
    failedPayments: number;
    monthlyBreakdown: Record<string, number>;
  };
  users: {
    totalUsers: number;
    roleCounts: Record<string, number>;
  };
  activity: Record<string, number>;
}

export const analyticsApi = {
  async getDashboard(filters?: AnalyticsFilterParams): Promise<DashboardStats> {
    const response = await apiClient.get<DashboardStats>('/analytics/dashboard', { params: filters });
    return response.data;
  },

  async getDealsByStage() {
    const response = await apiClient.get('/analytics/deals/by-stage');
    return response.data;
  },

  async getStaffPerformance(filters?: AnalyticsFilterParams) {
    const response = await apiClient.get('/analytics/staff/performance', { params: filters });
    return response.data;
  },

  async getRevenue(filters?: AnalyticsFilterParams) {
    const response = await apiClient.get('/analytics/revenue', { params: filters });
    return response.data;
  },

  async getUserStats() {
    const response = await apiClient.get('/analytics/users');
    return response.data;
  },

  async getActivity(filters?: AnalyticsFilterParams) {
    const response = await apiClient.get('/analytics/activity', { params: filters });
    return response.data;
  },
};
